export default __webpack_public_path__ + "static/media/023-nature protection.8ab95f80.svg";